/**
 * Sends a custom event to Clarity
 *
 * @param eventName - The name of the event to track
 * @example
 * ```ts
 * import { sendClarityEvent } from '@/services/clarity'
 *
 * sendClarityEvent('gift_wrap_added')
 * ```
 */
export const sendClarityEvent = (eventName: string): void => {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') {
    if (import.meta.env.DEV) {
      console.warn('[Clarity] Event not sent - Clarity not loaded:', eventName)
    }
    return
  }

  try {
    window.clarity('event', eventName)
  } catch (error) {
    // Silently fail if Clarity is not available or errors occur
    console.warn('Failed to send Clarity event:', error)
  }
}
